"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Link = function (_a) {
    var className = _a.className, color = _a.color, negative = _a.negative, primary = _a.primary, subdued = _a.subdued, props = __rest(_a, ["className", "color", "negative", "primary", "subdued"]);
    var LinkElement = props.href ? 'a' : 'span';
    var LinkColor = color;
    // Override string props with boolean values
    if (primary)
        LinkColor = 'primary';
    if (negative)
        LinkColor = 'negative';
    if (subdued)
        LinkColor = 'subdued';
    var LinkColorClasses = {
        primary: 'Link--blue',
        blue: 'Link--blue',
        negative: 'Link--red',
        red: 'Link--red',
        subdued: 'Link--grey',
        grey: 'Link--grey',
    };
    var LinkColorClass = LinkColor ? LinkColorClasses[LinkColor] : '';
    var LinkClasses = classnames_1.default('Link', className, LinkColorClass);
    return (react_1.default.createElement(LinkElement, __assign({ role: "link", className: LinkClasses }, props), props.children));
};
exports.Link = Link;
//# sourceMappingURL=Link.js.map